import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import type { RootState } from '../configureStore';
import type { Case } from '../../data/types';

export type CaseState = {
    case: Case | null,
}

export const useCaseState = () => {
    const caseState = useSelector((state: RootState) => state.cases);
    return caseState;
}

const initialState: CaseState = {
    case: null,
}

export const caseSlice = createSlice({
    name: 'cases',
    initialState: initialState,
    reducers: {
        setCaseAction: (state, action: PayloadAction<Case>) => {
            state.case = action.payload;
        },
        updateCaseAction: (state, action: PayloadAction<Case>) => {
            if (state.case && state.case.caseId === action.payload.caseId && state.case.accountId === action.payload.accountId) {
                state.case = action.payload;
            }
        },
        clearCaseAction: (state) => {
            state.case = null;
        },
    }
})

export const { setCaseAction, updateCaseAction, clearCaseAction } = caseSlice.actions;

export default caseSlice.reducer;